import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import JsonLd from "@/components/base/JsonLd";
import Breadcrumb from "@/components/feature/Breadcrumb";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";
import ContactForm from "./components/ContactForm";

const ORIGIN = "https://ymw88.top";

const channels = [
  {
    icon: "ri-mail-line",
    title: "邮件联系",
    desc: "适合正式沟通与较长说明，我们会在两个工作日内回复。",
    value: "hi@heichigua.example.com",
  },
  {
    icon: "ri-file-add-line",
    title: "线索投递",
    desc: "欢迎提供公开可查的话题线索，请附上来源说明以便核实。",
    value: "表单提交 · 标注「线索投递」",
  },
  {
    icon: "ri-team-line",
    title: "品牌合作",
    desc: "栏目合作、内容共创与专题策划均可洽谈。",
    value: "表单提交 · 标注「品牌合作」",
  },
];

export default function Contact() {
  useSeo({
    title: "联系我们 - 黑吃瓜网线索投递与商务合作",
    description:
      "通过黑吃瓜网联系表单进行线索投递、内容更正或品牌合作沟通，也可以直接发送邮件，我们会在两个工作日内回复。",
    keywords: "联系黑吃瓜网,线索投递,内容更正,品牌合作",
    path: "/contact",
  });

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "联系我们",
      url: `${ORIGIN}/contact`,
      inLanguage: "zh-CN",
      description: "黑吃瓜网的联系方式与线索投递入口。",
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "黑吃瓜网",
      url: `${ORIGIN}/`,
      email: "hi@heichigua.example.com",
      contactPoint: {
        "@type": "ContactPoint",
        email: "hi@heichigua.example.com",
        contactType: "customer support",
        availableLanguage: ["zh-CN"],
      },
    },
  ];

  return (
    <>
      <JsonLd data={jsonLd} />

      <section className="w-full bg-background-100 border-b border-background-200">
        <div className="w-full px-4 md:px-8 py-10 md:py-14">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "联系我们" }]} />
          <h1 className="mt-4 font-heading font-bold text-3xl md:text-5xl text-foreground-950 leading-tight max-w-3xl">
            有话想说，随时找我们
          </h1>
          <p className="mt-5 text-sm md:text-base text-foreground-700 max-w-2xl leading-relaxed">
            无论是线索投递、内容更正，还是合作咨询，都可以通过下面的表单或邮件联系我们。我们读得比较慢，但每一条都会认真看。
          </p>
        </div>
      </section>

      <section className="w-full bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-8 py-10 md:py-14">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-10">
            {channels.map((item) => (
              <div key={item.title} className="p-5 rounded-lg border border-background-200 bg-background-100">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h2 className="mt-4 font-heading font-bold text-base text-foreground-950">{item.title}</h2>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                <p className="mt-3 text-sm font-medium text-primary-700 break-all">{item.value}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
            <div className="lg:col-span-7">
              <ContactForm />
            </div>

            <aside className="lg:col-span-5">
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-4">提交前先看看</h2>
              <FaqAccordion items={faqs.slice(0, 4)} />
              <div className="mt-6 p-5 rounded-lg border border-primary-200 bg-primary-50">
                <h3 className="font-heading font-bold text-base text-primary-900">想直接看内容？</h3>
                <p className="mt-1.5 text-sm text-primary-800 leading-relaxed">
                  今天的爆料已经更新好了，点下面的按钮直接进入列表。
                </p>
                <Link
                  to="/breaking"
                  className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  今日爆料列表
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </>
  );
}